import { MenuButton } from '@driftt/dds'
import PlaybookCreatorModal from '@driftt/playbook-creator-modal'
import { receiveUserSettings } from '@driftt/traffic-control'
import { pathOr } from 'ramda'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

import { getMenuOptions } from './utils'

import './style.css'

const mapStateToProps = (state) => ({
  gates: pathOr({}, ['user', 'gates'], state),
  userId: pathOr(null, ['user', 'id'], state),
  integrationStatus: pathOr({}, ['integrations', 'status'], state),
})

const mapDispatchToProps = (dispatch) => ({
  onReceiveUserSettings: (settings) => {
    dispatch(receiveUserSettings(settings))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function PlaybooksCreationMenu({
  hasAnyPlaybookAccess,
  gates,
  history,
  integrationStatus,
  pathNames,
}) {
  const [isMarketplaceOpen, setIsMarketplaceOpen] = useState(false)
  const [selectedPlaybookType, setSelectedPlaybookType] = useState(null)

  const toggleMarketplace = () => setIsMarketplaceOpen((open) => !open)

  const menuOptions = getMenuOptions(
    pathNames,
    hasAnyPlaybookAccess,
    history,
    toggleMarketplace,
    setSelectedPlaybookType
  )

  return (
    <>
      <MenuButton buttonText="Create a playbook" options={menuOptions} />
      {isMarketplaceOpen &&
        ReactDOM.createPortal(
          <PlaybookCreatorModal
            onClose={toggleMarketplace}
            gates={gates}
            integrationStatus={integrationStatus}
            playbookType={selectedPlaybookType}
          />,
          document.getElementById('pew-modal-root')
        )}
    </>
  )
})
